import type { ReactElement } from "react";
import { LoadingSpinner } from "../../../../shared/components/loading/LoadingSpinner";

interface FileUploadZoneProps {
  type: string;
  uploading: boolean;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>;
}

/**
 * File Upload Zone Component
 */
export function FileUploadZone({ type, uploading, onFileChange }: Readonly<FileUploadZoneProps>): ReactElement {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    onFileChange(e);
  };

  return (
    <div className="relative">
      <input
        type="file"
        accept="image/jpeg,image/png,image/webp"
        onChange={handleChange}
        disabled={uploading}
        className="hidden"
        id={`file-${type}`}
      />
      <label
        htmlFor={`file-${type}`}
        className={`flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-lg cursor-pointer transition-colors ${
          uploading
            ? "border-neutral-700 bg-neutral-900 cursor-not-allowed"
            : "border-neutral-700 hover:border-lumi-accent bg-neutral-900 hover:bg-neutral-800"
        }`}
      >
        {uploading ? (
          <div className="flex flex-col items-center">
            <LoadingSpinner size="sm" />
            <p className="mt-2 text-sm text-neutral-400">Uploading...</p>
          </div>
        ) : (
          <>
            <svg className="w-10 h-10 text-neutral-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
              />
            </svg>
            <p className="mt-2 text-sm text-neutral-400">Click to upload or drag and drop</p>
            <p className="text-xs text-neutral-500">PNG, JPG, WebP (max 5MB)</p>
          </>
        )}
      </label>
    </div>
  );
}
